module.exports = "/images/vendor/flag-icon-css/flags/1x1/pl.svg?3fe3bd51a504e4239ca5adaeb17a1651";